import React from 'react';

import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import classes from './BobConfirmButton.module.css';

const BobConfirmButton = ({
    children,
    className,
    confirm,
    disabled,
    hidden,
    isLoading,
    label,
    onClick,
    type,
    iconSize,
    ...props
}) => {
    if (hidden) return null;

    let content = children || label;

    if (confirm) {
        onClick = confirm;
    }

    if (isLoading) {
        content = (
            <React.Fragment>
                <CircularProgress
                    className={clsx(
                        classes.progress,
                        {
                            [classes.disabledProgress]: disabled
                        }
                    )}
                    size={iconSize || 25}
                />
                <span>{content}</span>
            </React.Fragment>
        );
    }

    return (
        <Button
            className={`${classes.Button} ${className}`}
            data-test-id="confirm"
            disabled={disabled || isLoading}
            onClick={onClick}
            variant="contained"
            {...props}
        >
            {content}
        </Button>
    );
};

export default BobConfirmButton;
